<template>
  <v-app>
    <v-main>
      <template v-if="application">
        <map-wrapper v-if="!configureError" />
        <v-img v-else-if="params('draft') === 'true'">
          <v-container class="px-5">
            <v-col class="text-center px-5 mb-5">
              <v-alert
                :value="true"
                type="warning"
                outlined
              >
                <h3>{{ configureError }}</h3>
              </v-alert>
            </v-col>
          </v-container>
        </v-img>
      </template>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MapWrapper from './components/MapWrapper.vue'

export default {
  name: 'App',
  components: {
    MapWrapper
  },
  data: () => ({}),
  computed: {
    ...mapState(['application', 'layers']),
    ...mapGetters(['config']),
    configureError () {
      if (!this.config.datasets || !this.config.datasets.length) return 'Veuillez configurer au moins un calque'
      for (const layer of this.config.layers) {
        if (layer.colors.type === 'field' && !layer.labelField) return 'Veuillez choisir la colonne de libellé pour les couleurs'
      }
      return null
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      async handler () {
        if (!this.layers.length) {
          const layers = []
          this.config.layers.slice().reverse().forEach((layer, i) => {
            const idx = this.config.layers.length - 1 - i
            if (layer.shapes.type === 'circle') {
              layers.unshift({ visible: !layer.hideAtStart, ids: ['layer-' + idx] })
            } else if (layer.shapes.type === 'shape') {
              layers.unshift({ visible: !layer.hideAtStart, ids: ['layer-' + idx, 'layer-' + idx + '-fill'] })
            } else if (layer.shapes.type === 'line') {
              layers.unshift({ visible: !layer.hideAtStart, ids: ['layer-' + idx] })
            } else {
              layers.unshift({ visible: !layer.hideAtStart, ids: ['layer-' + idx] })
            }
            layers[0].qsFilters = layer.filters
            layers[0].dataset = layer.dataset
          })
          if (this.config.oneLayerVisible && layers.length) {
            layers.forEach(l => { l.visible = false })
            layers[0].visible = true
          }
          this.$store.commit('setAny', { layers })
        }
        const conceptFilters = {}
        const dFilters = {}
        for (const idx in this.layers) dFilters[idx] = {}
        for (const key in this.$route.query) {
          if (key.startsWith('_c_')) {
            conceptFilters[key] = this.$route.query[key]
          }
          if (key.startsWith('_d_') && !key.endsWith('_id_eq') && !key.endsWith('_id_in')) {
            const toks = key.slice(3).split('_')
            const datasetId = toks.shift()
            const filter = toks.join('_')
            const idx = this.config.layers.findIndex(l => l.dataset.id === datasetId)
            dFilters[idx][filter] = this.$route.query[key]
          }
        }
        console.log(dFilters)
        for (const idx in dFilters) this.$store.commit('filter', { i: idx, filters: dFilters[idx] })
        this.$store.commit('setAny', { conceptFilters })
        if (this.params('draft') === 'true') {
          this.setApplications()
          this.setDatasets()
        } else if (!this.configureError) this.$store.dispatch('init')
      }
    }
  },
  mounted () {
    window.vIframeOptions = {
      router: this.$router,
      reactiveParams: true
    }
  },
  methods: {
    params (p) {
      const params = new URLSearchParams(window.location.search)
      return params.get(p)
    },
    setDatasets () {
      const embedDatasets = (this.config.layers || []).filter(l => l?.embed?.type === 'embed' && l.embed.element?.type === 'tablePreview' && l.embed.element.dataset?.id).map(l => l.embed.element.dataset)
      const datasets = (this.config.layers || []).map(l => l.dataset).concat(embedDatasets)
      const datasetsLayers = datasets.map(d => d.id).filter((id, i, s) => s.indexOf(id) === i).sort()
      const datasetsConfig = (this.config.datasets || []).map(d => d.id).filter((id, i, s) => s.indexOf(id) === i).sort()
      if (datasetsLayers.toString() === datasetsConfig.toString()) {
        this.$store.dispatch('init')
        return
      }
      if (window.parent) window.parent.postMessage({ type: 'set-config', content: { field: 'datasets', value: datasets.filter((d1, i, s) => s.findIndex(d2 => d1.id === d2.id) === i) } }, '*')
    },
    setApplications () {
      const applications = (this.config.layers || []).filter(l => l?.embed?.type === 'embed' && l.embed.element?.type === 'application' && l.embed.element.application?.id).map(l => ({ id: l.embed.element.application.id, title: l.embed.element.application.title }))
      if (window.parent && (this.config.applications || []).map(a => a.id).join('-') !== applications.map(a => a.id).join('-')) window.parent.postMessage({ type: 'set-config', content: { field: 'applications', value: applications } }, '*')
    }
  }
}
</script>

<style>
.v-application {
  font-family: "Nunito", sans-serif !important;
}
</style>
